import styled from '@emotion/styled';

const GroupUsers = styled('div')(({ theme }) => ({
  marginLeft: 6,
  marginRight: 'auto',
  color: theme.palette.text.secondary
}));

export default GroupUsers;
